import { render } from "./LegacyEmailFields.vue?vue&type=template&id=082a9aaa"
import script from "./LegacyEmailFields.vue?vue&type=script&lang=js"
export * from "./LegacyEmailFields.vue?vue&type=script&lang=js"
script.render = render

export default script